<section class="tiptap-markdown-editor" [class.tiptap-markdown-editor--dark]="isDarkMode" [class.tiptap-markdown-editor--fullscreen]="isFullscreen">
  <header class="tiptap-markdown-editor__toolbar" aria-label="Markdown 編輯工具列">
    <button type="button" (click)="toggleBold()" [disabled]="isDisabled || isReadonly" aria-label="粗體"><strong>B</strong></button>
    <button type="button" (click)="toggleItalic()" [disabled]="isDisabled || isReadonly" aria-label="斜體"><em>I</em></button>
    <button type="button" (click)="toggleStrike()" [disabled]="isDisabled || isReadonly" aria-label="刪除線"><s>S</s></button>
    <button type="button" (click)="toggleHeading(1)" [disabled]="isDisabled || isReadonly" aria-label="標題一">H1</button>
    <button type="button" (click)="toggleHeading(2)" [disabled]="isDisabled || isReadonly" aria-label="標題二">H2</button>
    <button type="button" (click)="toggleHeading(3)" [disabled]="isDisabled || isReadonly" aria-label="標題三">H3</button>
    <button type="button" (click)="toggleBulletList()" [disabled]="isDisabled || isReadonly" aria-label="項目清單">• List</button>
    <button type="button" (click)="toggleOrderedList()" [disabled]="isDisabled || isReadonly" aria-label="編號清單">1. List</button>
    <button type="button" (click)="toggleTaskList()" [disabled]="isDisabled || isReadonly" aria-label="工作清單">☐ Task</button>
    <button type="button" (click)="toggleBlockquote()" [disabled]="isDisabled || isReadonly" aria-label="引用">Quote</button>
    <button type="button" (click)="toggleCodeBlock()" [disabled]="isDisabled || isReadonly" aria-label="程式碼區塊">Code</button>
    <button type="button" (click)="insertTable()" [disabled]="isDisabled || isReadonly" aria-label="插入表格">Table</button>
    <button type="button" (click)="insertLink()" [disabled]="isDisabled || isReadonly" aria-label="插入連結">Link</button>
    <span class="tiptap-markdown-editor__spacer"></span>
    <button type="button" (click)="toggleDarkMode()" aria-label="切換深色模式">{{ isDarkMode ? '淺色' : '深色' }}</button>
    <button type="button" (click)="toggleFullscreen()" aria-label="切換全螢幕">{{ isFullscreen ? '離開全螢幕' : '全螢幕' }}</button>
  </header>

  <div class="tiptap-markdown-editor__body">
    <div class="tiptap-markdown-editor__editor" [class.tiptap-markdown-editor__editor--readonly]="isReadonly || isDisabled">
      @if (editor; as activeEditor) {
        <div tiptap [editor]="activeEditor"></div>
      }
    </div>
    <aside class="tiptap-markdown-editor__preview">
      <p class="tiptap-markdown-editor__preview-title">即時預覽（Mermaid 僅在此區渲染）</p>
      <div class="markdown-body" [appMermaidRenderer]="markdown"></div>
    </aside>
  </div>
</section>
